<h2 mat-dialog-title><mat-icon>warning</mat-icon> Custom Interval Override Warning</h2>
<mat-dialog-content class="mat-dialog-content">
    <p>
        The {{groupType}} group type does not allow custom escalation or reminder intervals. If you select this type, your Escalation Frequency and Reminder Frequency settings will be overwritten.
    </p>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions" id="dialogActions">
    <button [mat-dialog-close]="true" mat-button id="Yes">I Accept</button>
    <button [mat-dialog-close]="false" mat-button id="No">Cancel</button>
</mat-dialog-actions>
